<template>
  <div>
    <canvas ref="batteryChart"></canvas>

    <v-card v-if="debug">
      <v-card-title>Debug Information</v-card-title>
      <v-card-text>
        UnitID:

        {{ UnitID }}
        <br />
        Time: {{ startTime }}

        <!-- Debug information goes here -->
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { Chart, registerables } from 'chart.js'
// import 'chartjs-adapter-moment' // Import the date adapter
import { format, parseISO, addDays } from 'date-fns'
import 'chartjs-adapter-date-fns'

// Register Chart.js components globally (required for Chart.js 3)
Chart.register(...registerables)

export default {
  props: ['startTime', 'UnitID', 'UnitModel2ID'],
  data () {
    return {
      debug: this.$debug,
      chart: null // Reference to the chart instance
    }
  },

  watch: {
    UnitModel2ID: {
      immediate: true,
      /**
         *
         *   Whenever the start time changes we request information from the database again
         *
         */
      handler (valNew, valOld) {
        if (valNew !== valOld) {
          // this.getData();
        }
      }
    },
    UnitID: {
      immediate: true,
      /**
       *
       *   Whenever the start time changes we request information from the database again
       *
       */
      handler (valNew, valOld) {
        if (valNew !== valOld) {
          // this.getData();
        }
      }
    },
    startTime: {
      /*  NB! immediate: true

          This is necessary as otherwise the default for day stands
          and not that carried by prop value on startup

          immediate : trigger the callback immediately on watcher creation.
          old value will be undefined on the first call.

      */
      immediate: true,
      /**
       *   deep: true,
       *
       *   Not necessary for this as it is simple object
       *
       *   deep: force deep traversal of the source if watch  is an object or an array,
       *   so that the callback fires on deep mutations. See Deep Watchers.
       *
       */
      // deep: true,
      /**
       *
       *   Whenever the start time changes we request information from the database again
       *
       */
      handler (valNew, valOld) {
        if (valNew !== valOld) {
          this.getFormAuthData()
        }
      }
    }
  },

  methods: {
    // Initialize the chart with data and options
    initChart (data) {
      // Extract labels and data points
      if (this.chart) {
        // Ensure chart is destroyed before creating a new one
        this.chart.destroy()
      }

      const labels = data.map((item) => item.DayHour.replace(/_/g, ' '))
      const carBatteryData = data.map((item) => item.CarBatteryMin)
      const carBatteryMaxData = data.map((item) => item.CarBatteryMax)

      const ctx = this.$refs.batteryChart.getContext('2d')

      // Create the chart instance
      this.chart = new Chart(ctx, {
        type: 'line',
        data: {
          labels: labels,
          datasets: [
            {
              label: this.UnitModel2ID === 38 ? 'Mole Battery Min' : 'Car Battery Min',
              data: carBatteryData,
              borderColor: 'rgba(75, 192, 192, 1)',
              backgroundColor: 'rgba(75, 192, 192, 0.2)',
              fill: false,
              tension: 0.1
            },
            {
              label: this.UnitModel2ID === 38 ? 'Mole Battery Max' : 'Car Battery Max',
              data: carBatteryMaxData,
              borderColor: 'rgba(255, 99, 132, 1)',
              backgroundColor: 'rgba(255, 99, 132, 0.2)',
              fill: false,
              tension: 0.1
            }
          ]
        },
        options: {
          responsive: true,
          scales: {
            x: {
              type: 'time',
              time: {
                unit: 'hour',
                tooltipFormat: 'yyyy-MM-dd HH',
                displayFormats: {
                  hour: 'MMM dd HH'
                }
              },
              title: {
                display: true,
                text: 'Date and Hour'
              }
            },
            y: {
              beginAtZero: true,
              title: {
                display: true,
                text: 'Battery Level (V)'

              }
            }
          },
          plugins: {
            legend: {
              position: 'top'
            },
            tooltip: {
              mode: 'index',
              intersect: false
            }
          }
        }
      })
    },

    /**
     *   V0.1.0 - 2022-08-22
     *
     *
     */
    getFormAuthData: function () {
      //

      // addDays(this.startTime, 1)
      var startTimeAddDay = format(
        parseISO(addDays(new Date(this.startTime), 1).toISOString()),
        'yyyy-MM-dd'
      )

      var url = this.$baseUrl
      url += '/api/v2/battery-level/between'
      url += `?UnitID=${this.UnitID}`
      url += `&Day=${startTimeAddDay}`
      // url += `&Day=${startTimeAddDay}`;

      if (this.$debug) {
        console.log(url)
      }

      this.loading = true

      this.$emit('loading', true)

      return this.$axios
        .get(url)
        .then((res) => {
          this.$emit('loading', false)
          this.loading = false

          if (this.$debug) {
            console.log('axios return:')
            console.log(res)
          }
          // this.points = res.data.$values;
          this.initChart(res.data)
        })
        .catch((error) => {
          this.$emit('loading', false)
          this.loading = false
          this.errorMessage = 'Unable to retrieve local test data .\r\n'
          this.errorMessage += error
          this.error = true
          console.log(error)
        })
    },

    /**
     *
     *     -   This function is used for testing the display without the need for the
     *         web api running
     *
     */
    getLocalData: function () {
      var url = ''
      url += 'api/view_BatteryLevels_.json'

      console.log(url)

      if (this.$debug) {
        console.log(url)
      }

      this.loading = true

      return this.$axios
        .get(url)
        .then((res) => {
          this.loading = false

          if (this.$debug) {
            console.log('axios return:')
            console.log(res)
          }

          this.initChart(res.data.$values)
        })
        .catch((error) => {
          this.loading = false
          this.errorMessage = 'Unable to retrieve local test data .\r\n'
          this.errorMessage += error
          this.error = true
          console.log(error)
        })
    }
  },
  mounted () {
    // this.getLocalData();

    this.getFormAuthData()
  },

  beforeDestroy () {
    // Destroy the chart instance before the component is destroyed
    if (this.chart) {
      this.chart.destroy()
    }
  }
}
</script>

<style scoped>
/* Optional: Add custom styling */
</style>
